// extracted by mini-css-extract-plugin
export default {"leftContainer":"sideSectionFrame_leftContainer__L3Puf","divider_h":"sideSectionFrame_divider_h__WkVYV","divider_v":"sideSectionFrame_divider_v__jCkCn"};